export default {
    onboarding: {
        actions: {
            mainBlue: 'Comience el cuestionario'
        }
    },
    details: {
        aboutProperty: 'Informaciones complementarias',
        title: 'Por favor confirme la siguiente información:',
        errorMsgInputTxt: 'Campos obligatorios',
        errorMsgGeneral: 'Revise el formulario antes de continuar',
        errorImages: 'Por favor, añada las fotos antes de continuar',
        address: {
            literal: 'Dirección',
            placeholder: 'Introduce una ubicación'
        },
        zipCode: {
            literal: 'Código postal'
        },
        propertyType: {
            literal: 'Tipo de propiedad',
            options: {
                appartment: 'Apartamento',
                maison: 'Casa',
                local_commercial: 'Local comercial'
            }
        },
        residentType: {
            literal: 'Tipo de residente',
            options: {
                propietarie: 'Propietario',
                locataire: 'Inquilino',
                propietarie_non_occupant: 'Arrendatario'
            }
        },
        moreThanTwoYears: {
            literal: 'Edad del inmueble',
            options: {
                more: 'Más de 2 años',
                less: 'Menos de 2 años'
            }
        },
        observations: {
            literal: 'Observaciones'
        },
        map: {
            empty: {
                title: 'No hay ubicación',
                text: 'Introduce una ubicación válida'
            }
        },
        textArea: {
            placeHolder: 'Longitud del texto limitada a 255 caracteres como máximo'
        }
    },
    closing: {
        actions: {
            mobilierButton: 'Continúa con daños en muebles'
        }
    },
    compensationType: {
        title: 'Gestionar una reclamación nunca ha sido tan fácil',
        subtitle: 'Acerca de los daños de su propiedad ',
        text: 'Para ello, ofrecemos tres posibles soluciones:',
        recommended: 'Nuestra recomendación!',
        amount: 'Importe reembolsado:',
        e2eCompensations: {
            gagDetail: {
                title: '¿Quieres hacerlo tú mismo?',
                text: 'Eres un manitas. Cubrimos el costo de los materiales, los costos de herramientas pequeñas y lo compensamos por el tiempo invertido.',
                link: 'Estimemos juntos tus necesidades'
            },
            billma: {
                title: 'Compensación en cotización',
                text: 'Adjunte fotos y facturas de los bienes dañados a su devolución. Nuestra unidad técnica lo validará.',
                link: 'Carga tu cotización'
            },
            renDetail: {
                title: 'Servicio de reparación',
                text: 'Utilice nuestro servicio de reparación. Infórmenos cuando esté disponible para una cita.',
                link: 'Pedir hora'
            }
        }
    },
    compensationMobilier: {
        title: 'Con respecto a los daños a su propiedad',
        subtitle: 'Monto de la compensación',
        total: 'Total:',
        totalAmount: 'Compensación total',
        actions: {
            primary: 'Sí, acepto la compensación propuesta',
            secondary: 'Quiero hablar con un asesor'
        }
    }
}